export const DarkGrey1 = `#333333`
export const LightGrey1 = `#949494`

export const defaultBoxShadow = `1px 1px 3px 0px rgba(0,0,0,0.2)`

export const textSizePar = `1.6rem`
export const subtitleSizeBig = `2.4rem`